/**
 * Set the session authenticity token on document to provide backwards compatibility for certain modules (futile/gofor, for example).
 */

import getMetaTagValue from '../../lib/getMetaTagValue';

if (typeof document !== 'undefined') {
    document.AUTH_TOKEN = getMetaTagValue('csrfToken');
}
